import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (18.35 / 24);
  const localHeight = size * (18.027 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 18.35 18.027">
      <path
        d="M3.483,15.674l-.029.028-.515-.51-.043-.04-.5-.482.025-.022c-2.756-3.14-3.586-8.028-.233-11.27l.172-.166L4.58,3.017,7.593,5.931,7.4,7.977l-.069.12A3.2,3.2,0,0,1,5.381,9.32,3.3,3.3,0,0,0,6.561,11.7a3.525,3.525,0,0,0,2.412,1.13h.044a3.1,3.1,0,0,1,1.263-1.884l.124-.067,2.116-.186,3.013,2.914-.2,2.144-.172.167a7.513,7.513,0,0,1-5.334,2.107A10.22,10.22,0,0,1,3.483,15.674ZM2.977,4.464c-2.744,2.855-1.736,7.178.879,9.775l.043.043.03.028a8.856,8.856,0,0,0,5.9,2.416,6.183,6.183,0,0,0,4.211-1.566l.1-1.062-2.122-2.052-1.141.1a3.044,3.044,0,0,0-.671,1.42l-.088.355-.359.113a2.761,2.761,0,0,1-.785.1,4.863,4.863,0,0,1-3.362-1.511c-2.1-2.063-1.5-3.94-1.469-4.019l.117-.347.367-.085a3.228,3.228,0,0,0,1.469-.649l.1-1.1L4.075,4.368ZM17.089,8.821A7.979,7.979,0,0,0,9,1.219H8.887V0H9A9.221,9.221,0,0,1,18.35,8.821Zm-2.985,0A5.041,5.041,0,0,0,9,4.1H8.887V2.886H9a6.282,6.282,0,0,1,6.364,5.936Z"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
